<template>
    <div>
        <div style="display:flex;justify-content: space-between;padding-bottom:20px">
            <div class="title">生产车间情况看板</div>
            <div class="time">{{time}}</div>
        </div>
        <el-card>
            <div slot="header">
                <span class="top_title">产量统计</span>
            </div>
            <div id="cc" style="height:160px;width:100%"></div>
            <div style="display:flex;justify-content: space-between">
                <div>分配生产数{{todayUnit.totalUnit+todayUnit.basePacking}}</div>
                <div>完成生产数{{todayUnit.completeUnit+todayUnit.basePacking}}</div>
                <div>今日产量{{todayUnit.todayComplete+todayUnit.basePacking}}</div>
            </div>
        </el-card>
        <div style="height:10px"></div>
        <el-card>
            <div slot="header">
                <span class="top_title">产量数据分析(当日)</span>
            </div>
            <div id="line_a" style="height:300px;width:100%"></div>
        </el-card>
        <div style="height:10px"></div>
        <el-card>
            <div slot="header">
                <span class="top_title">正在生产</span>
            </div>
            <el-table :data="workingRecord" max-height="500">
                <el-table-column label="产品" width="190">
                    <template slot-scope="{row}">
                        <div style="width:180px">{{"["+row.pnumber+"]"+row.pname}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="双数" prop="totalUnit" width="110"></el-table-column>
                <el-table-column label="流程">
                    <template slot-scope="{row}">
                        <div>
                            <el-tag v-for="(item,index) in row.process" :key="index" effect="plain">{{item.name+"["+item.per+"]"}}</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="进度" width="80">
                    <template slot-scope="{row}">
                        <el-tag effect="dark" type="success">{{row.per}}</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <div style="height:10px"></div>
        <el-card>
            <div slot="header">
                <span class="top_title">今日计件记录</span>
            </div>
            <el-table :data="scanRecord" max-height="500">
                <el-table-column label="时间" prop="date"></el-table-column>
                <el-table-column label="员工" prop="ename"></el-table-column>
                <el-table-column label="计件码" prop="number"></el-table-column>
                <el-table-column label="工序" prop="prName"></el-table-column>
                <el-table-column label="产品" prop="pname"></el-table-column>
                <el-table-column label="双数" prop="unit"></el-table-column>
                <el-table-column label="今日双数" prop="todayUnitSum"></el-table-column>
            </el-table>
        </el-card>
        <div style="height:10px"></div>
        <el-card>
            <div slot="header">
                <span class="top_title">计件二维码补打</span>
            </div>
            <div id="bar_a" style="height:300px;width:100%"></div>
        </el-card>
        <div style="height:10px"></div>
        <el-card>
            <div slot="header">
                <span class="top_title">废弃二维码</span>
            </div>
            <div id="bar_b" style="height:300px;width:100%"></div>
        </el-card>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    data(){
        return{
            time:'',
            t:null,
            todayUnit:{
                todayComplete:'',
                totalUnit:'',
                completeUnit:'',
                basePacking:'',
                per:'',
            },
            scData:[],
            scYData:[],
            workingRecord:[],
            scanRecord:[],

            ccData:[],
            ccYData:[],
            muData:[],
            muYData:[],
        }
    },
    created(){
        this.timeChange();
        this.getInfo();
    },
    methods:{
        getInfo:function(){
            this.$api.panelData().then(res=>{
                if(res.data.code==1){
                    let data = res.data.data;
                    this.todayUnit = data.todayUnit;
                    this.todayUnit.per = this.todayUnit.per.slice(0,-1);
                    this.scData = data.scanCount.data;
                    this.scYData = data.scanCount.ydata;
                    this.workingRecord = data.workingRecord;
                    this.scanRecord = data.scanRecord;
                    this.ccData = data.codeCount.cancel.data;
                    this.ccYData = data.codeCount.cancel.ydata;
                    this.muData = data.codeCount.makeUp.data;
                    this.muYData = data.codeCount.makeUp.ydata;
                    this.initCC();
                    this.initLinea();
                    this.initBara();
                    this.initBarb();
                }
            })
        },
        timeChange:function(){
            this.t = setInterval(()=>{
                this.time = this.$common.formats(new Date());
            },1000);
        },
        initCC:function(){
            this.$nextTick(()=>{
                let myChart = echarts.init(document.getElementById('cc'));
                let option = {
                    series: [
                        {
                            type: 'gauge',
                            startAngle: 90,
                            endAngle: -270,
                            pointer: {
                                show: false
                            },
                            progress: {
                                show: true,
                                overlap: false,
                                roundCap: true,
                                clip: false,
                                itemStyle: {
                                    borderWidth: 1,
                                    borderColor: '#FF9B0F',
                                    color:"#FF9B0F"
                                }
                            },
                            axisLine: {
                                lineStyle: {
                                    width: 10,
                                    color: [[1, '#4176FF']],
                                }
                            },
                            splitLine: {
                                show: false,
                                distance: 0,
                                length: 10
                            },
                            axisTick: {
                                show: false
                            },
                            axisLabel: {
                                show: false,
                                distance: 50
                            },
                            data: [{
                                value: this.todayUnit.per,
                                name: '完成度',
                                title: {
                                    offsetCenter: ['0%', '-30%']
                                },
                                detail: {
                                    valueAnimation: true,
                                    offsetCenter: ['0%', '30%']
                                } 
                            }],
                            title: {
                                fontSize: 14
                            },
                            detail: {
                                width: 50,
                                height: 14,
                                fontSize: 14,
                                color: 'inherit',
                                borderColor: 'inherit',
                                borderRadius: 20,
                                borderWidth: 1,
                                formatter: '{value}%'
                            }
                        }
                    ]
                };
                myChart.setOption(option);
            })
        },
        initLinea:function(){
            this.$nextTick(()=>{
                let myChart = echarts.init(document.getElementById('line_a'));
                let option = {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "shadow"
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: this.scData,
                    },
                    yAxis: {
                        type: 'value',
                    },
                    series: [
                        {
                            name:'生产数',
                            data: this.scYData,
                            type: 'line',
                            smooth: true
                        }
                    ]
                };
                myChart.setOption(option);
            })
        },
        initBara:function(){
            this.$nextTick(()=>{
                let myChart = echarts.init(document.getElementById('bar_a'));
                let option = {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "shadow"
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: this.muData,
                    },
                    yAxis: {
                        type: 'value',
                    },
                    series: [
                        {
                            name:'补打数',
                            data: this.muYData,
                            type: 'bar'
                        }
                    ]
                };
                myChart.setOption(option);
            })
        },
        initBarb:function(){
            this.$nextTick(()=>{
                let myChart = echarts.init(document.getElementById('bar_b'));
                let option = {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "shadow"
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: this.ccData,
                    },
                    yAxis: {
                        type: 'value',
                    },
                    series: [
                        {
                            name:'废弃数',
                            data: this.ccYData,
                            type: 'bar'
                        }
                    ]
                };
                myChart.setOption(option);
            })
        }
    },
    beforeDestroy() {
        clearInterval(this.t);
    },
}
</script>

<style scoped>
.title{
    height: 60px;
    line-height: 60px;
    font-size: 24px;
    color: #fff;
    padding: 0 20px;
    background: #4176ff;
    border-radius: 10px;
}
.time{
    line-height: 60px;
    font-size: 24px;
}
.el-tag{
    border:none;
}
</style>